import map from "lodash/map";

export const massageDocumentTypeList = (tempList: any) => {
  return map(tempList, (tempItem) => {
    return {
      code: tempItem?.code,
      value: tempItem?.value
    }
  })
}